import livr from 'livr';
import { MIN_LOAN_TERM, MAX_LOAN_TERM, MIN_AGE, MAX_AGE } from '../constants.js';
import formatter from './error-formatter.js';

var inputValidator = new livr.Validator({
  salePrice: ['required', 'positive_decimal'],
  downPayment: ['required', 'positive_decimal'],
  loanTerm: ['required', 'positive_integer', {
    number_between: [MIN_LOAN_TERM, MAX_LOAN_TERM]
  }],
  age: ['required', 'positive_integer', {
    number_between: [MIN_AGE, MAX_AGE]
  }]
});

var validateInput = function validateInput(params) {
  var validParams = inputValidator.validate(params);
  var paramsErrors = inputValidator.getErrors();

  if (paramsErrors) {
    throw new Error(formatter(paramsErrors, params));
  }

  return validParams;
};

export default validateInput;
